import { WrenchIcon } from '@heroicons/react/24/solid';
import { CalendarEventChipRenderProps } from '../types';
import { CalendarChip } from './CalendarChip';

export const TaskChip = ({ eventInfo }: CalendarEventChipRenderProps) => {
  const { timeText, type, reason } = eventInfo.event.extendedProps;

  return (
    <CalendarChip
      eventInfo={eventInfo}
      className="bg-slate-200 border border-dashed border-slate-400 text-foreground/95 font-semibold"
    >
      <span>
        <WrenchIcon className="size-4 mr-1 text-slate-600 display-inline" />
        {eventInfo.event.title}
      </span>
    </CalendarChip>
  );
};
